import styles from '#components/common/teaser-meta/TeaserOverline.module.scss';
import React, { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  element?: 'h3' | 'h4';
};

const TeaserOverline: FC<Props> = ({ element = 'h4', children }) => {
  return React.createElement(element, { className: styles.host }, children);
};

export default TeaserOverline;
